import { Injectable } from '@angular/core';
import { MmuLogLevel } from './mmu-log-level.enum';
import { MMU_LOG_LEVEL } from './mmu-log-level.token';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LogFn = (...args: any[]) => void;

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop: LogFn = (): void => {
};

@Injectable({
  providedIn: 'root',
  useFactory: (level: MmuLogLevel | undefined) => new MmuDefaultLogger(undefined, level),
  deps: [MMU_LOG_LEVEL]
})
export abstract class MmuLogger {
  abstract logLevel?: MmuLogLevel;
  trace: LogFn = noop;
  debug: LogFn = noop;
  log: LogFn = noop;
  info: LogFn = noop;
  warn: LogFn = noop;
  error: LogFn = noop;
}

export class MmuDefaultLogger extends MmuLogger {
  constructor(
    readonly name?: string,
    readonly logLevel?: MmuLogLevel
  ) {
    super();

    this.logLevel = this.logLevel ?? MmuLogLevel.WARN;

    if (this.logLevel === MmuLogLevel.SILENT) {
      // No logging - keep noop functions
      return;
    }

    if (this.logLevel <= MmuLogLevel.TRACE) {
      this.trace = this.getLogFn('trace');
    }

    if (this.logLevel <= MmuLogLevel.DEBUG) {
      this.debug = this.getLogFn('debug');
    }

    if (this.logLevel <= MmuLogLevel.INFO) {
      this.info = this.getLogFn('info');
      this.log = this.getLogFn('log');
    }

    if (this.logLevel <= MmuLogLevel.WARN) {
      this.warn = this.getLogFn('warn');
    }

    if (this.logLevel <= MmuLogLevel.ERROR) {
      this.error = this.getLogFn('error');
    }
  }

  getLogFn(fn: keyof Pick<typeof window.console, 'error' | 'warn' | 'info' | 'log' | 'debug' | 'trace'>): LogFn {
    // Make sure the console object and the console function exist
    if (!window.console || !window.console[fn]) {
      return noop;
    }

    return this.name ?
           window.console[fn].bind(window.console, `[${this.name}]:`) :
           window.console[fn].bind(window.console);
  }
}
